import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, CTA_LABEL, GUARANTEE_LINE, RATING_LINE } from '../data/site';
const included = ['6 moduli principali', '5 bonus complementari', 'Materiale didattico in inglese', 'Accesso immediato', 'Risorse pronte da utilizzare e adattare'];
export function PricingCard() {
  const [seconds, setSeconds] = useState(5400);
  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prev => prev <= 1 ? 5400 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  const units = [{
    value: pad(Math.floor(seconds / 3600)),
    label: 'ORE'
  }, {
    value: pad(Math.floor(seconds % 3600 / 60)),
    label: 'MINUTI'
  }, {
    value: pad(seconds % 60),
    label: 'SECONDI'
  }];
  return <section id="offerta" className="scroll-mt-2 border-y-4 border-brand-green bg-white px-4 py-7" data-id="element-148" data-mp="2sszxyao396ve">
      <div className="mx-auto max-w-2xl text-center" data-id="element-149" data-mp="32k2gf0zyzn1f">
        <p className="font-display text-sm font-extrabold uppercase tracking-wider text-brand-green sm:text-base" data-id="element-150" data-mp="32mf5rz824zoi">
          Offerta speciale — Sistema completo 6-in-1
        </p>
        <p className="mx-auto mt-2 max-w-xl text-[15px] font-medium leading-snug text-brand-graphite" data-id="element-151" data-mp="2stzo730oad45">
          Accedi a ENGLISH TEACHER PRO™ e porta nelle tue lezioni un sistema
          completo di materiale didattico già organizzato e pronto all’uso.
        </p>

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-152" data-mp="2ot7e67jz846t">
          <img src={BOX_IMAGE} alt="Box ENGLISH TEACHER PRO™ — sistema completo 6-in-1" className="mx-auto w-full max-w-[280px] drop-shadow-2xl" data-id="element-153" data-mp="2oqkzzp2kyqfm" />
        </a>

        <div className="mt-3 rounded-xl border-4 border-brand-navy bg-brand-cream p-4" data-id="element-154" data-mp="84acgyv9n7fo">
          <p className="font-display text-lg font-extrabold uppercase leading-tight text-brand-navy sm:text-xl" data-id="element-155" data-mp="82h5figqql75">
            <span aria-hidden="true" data-id="element-156" data-mp="bm7uah1c8atw">🇬🇧</span> ENGLISH TEACHER PRO™
          </p>
          <p className="mt-1 text-[13px] font-bold leading-snug text-brand-graphite" data-id="element-157" data-mp="bjv27b1v8k34">
            The Complete Ready-to-Use Teaching System for English Teachers
          </p>

          <p className="mt-3 text-left text-[13px] font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-158" data-mp="1ojvng0m2j6g">
            Include:
          </p>
          <ul className="mt-1.5 grid gap-1 text-left sm:grid-cols-2" data-id="element-159" data-mp="ucfsqlu3ed3r">
            {included.map(item => <li key={item} className="text-[13px] font-semibold leading-snug text-brand-graphite" data-id="element-160" data-mp="pd49952cctih">
                <span className="font-extrabold text-brand-green" data-id="element-161" data-mp="kl319vc7hoy9">✓</span> {item}
              </li>)}
          </ul>

          <div className="mt-4 border-t-2 border-brand-navy/10 pt-3" data-id="element-162" data-mp="1d36wn7vb9bar">
            <p className="text-[13px] font-bold text-brand-graphite/70" data-id="element-163" data-mp="1d4i2dd8bgt4i">
              Prezzo di Listino: <span className="line-through" data-id="element-164" data-mp="18ax8nxdralb4">97€</span>
            </p>
            <p className="mt-1 font-display text-sm font-extrabold uppercase leading-tight text-brand-orange sm:text-base" data-id="element-165" data-mp="2r002klg7uohs">
              🔥 72% di sconto — Offerta di lancio a tempo limitato
            </p>
            <p className="mt-1 font-display text-5xl font-extrabold leading-none text-brand-navy sm:text-6xl" data-id="element-166" data-mp="2zyvfegdrmwu2">
              OGGI SOLO: 27€
            </p>
            <p className="mt-1 text-[12px] font-semibold text-brand-graphite/70" data-id="element-167" data-mp="39y41kn2e375v">
              Pagamento sicuro nella tua valuta.
            </p>
          </div>

          <div className="mt-3 rounded-lg border-2 border-brand-orange/50 bg-white p-3" data-id="element-168" data-mp="3evmawekbjoee">
            <p className="text-[12px] font-extrabold uppercase leading-snug text-brand-orange" data-id="element-169" data-mp="3jofj5cezxev8">
              ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
            </p>
            <div className="mt-2 flex justify-center gap-2" data-id="element-170" data-mp="3spwvcjpa8wen">
              {units.map(unit => <div key={unit.label} className="text-center" data-id="element-171" data-mp="1j2k5t0v6bju">
                  <div className="rounded bg-brand-navy px-2.5 py-1.5 font-display text-xl font-extrabold tabular-nums text-white sm:text-2xl" data-id="element-172" data-mp="3k0oh4rvho21l">
                    {unit.value}
                  </div>
                  <p className="mt-0.5 text-[9px] font-extrabold tracking-widest text-brand-graphite/60" data-id="element-173" data-mp="3trasub0348f0">
                    {unit.label}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="mt-3" data-id="element-174" data-mp="312vfru0ik06b">
            <CTAButton href={CHECKOUT_URL} data-id="element-175" data-mp="3146mo2p99o1n">{CTA_LABEL}</CTAButton>
          </div>

          <p className="mt-2 text-[13px] font-bold text-brand-graphite" data-id="element-176" data-mp="2w4txhbaww4vw">
            {RATING_LINE}
          </p>
          <p className="text-[13px] font-bold text-brand-graphite" data-id="element-177" data-mp="3ay6xml77xnia">
            {GUARANTEE_LINE}
          </p>
        </div>
      </div>
    </section>;
}